jQuery(document).ready(function ($) {
  $('#header .menu .menu-item-has-children > a').on('click', function (e) {
    e.preventDefault();
    $(this).parent().toggleClass('open');
  });
  $('#header .nav-toggle').click(function () {
    $('.nav-container').toggleClass('active');
    $('.overlay').toggle();
  });
  $('.overlay, .action-close i').click(function () {
    $('.nav-container').removeClass('active');
    $('.overlay').hide();
  });
  $('.top-search a.search-toggle').click(function () {
    $('.top-search-form').toggle();
  });
  $('#header .mobile-nav-toggle').click(function () {
    $('.mobile-menu').toggle(100);
  });

  $('.form-mailinglist').submit(function(e){
    submitMailingList(this);
    console.log(111);
    e.preventDefault();
  });
});



function submitMailingList(theForm) {
  var varInputId = $(theForm).find('input[type=text]');
  var strErrorMsg = $(varInputId).attr("data-error"); 
  var strGeneralErrorMsg = $(varInputId).attr("data-generalerror"); 
  var source = $(theForm).find("input[name='scid']").val(); 
  var dataString = $(theForm).serialize(); 
  
  $.ajax({
    url: 'https://www.disneymusicemporium.com/store/ajaxEmailOptIn?return=true&mode=' + source, 
    type: 'post', 
    cache: false, 
    dataType: "json", 
    data: dataString,
    crossDomain: true,
    headers: {
      'Access-Control-Allow-Origin': '*'
    },
    success: function (data) {
      if (data.errors.length > 0) { 
        $(varInputId).val("").attr("placeholder", strErrorMsg).addClass("InputError"); 
      } else { 
        $(varInputId).val("").attr("placeholder", data.successText); 
      }
    }, 
    error: function (data) { 
      $(varInputId).val("").attr("placeholder", strGeneralErrorMsg).addClass("InputError"); 
    }
  });
} 
  